import { gql } from '@apollo/client';

export const putRFXRequestMutation = gql`
  mutation putRFXRequest($rfxRequest: RFXRequestInput!) {
    putRFXRequest(rfxRequest: $rfxRequest) {
      rfxRequestRevisionedId {
        id {
          value
        }
        revision
      }
      rfxRequestVersion
    }
  }
`;
